import { ColorPicker } from "@/components/ColorPicker/colorPicker";
import { sendUpdateTag } from "@/models/tags.model";
import { AppContext } from "@/services/AppContext/appContext";
import { Button } from "@/shadcn/components/ui/button";
import { Input } from "@/shadcn/components/ui/input";
import { Tag } from "@/types";
import { genericFailureToast, genericSuccessToast } from "@/utils/utils";
import React, { useContext, useEffect, useState } from "react";

type TagsViewSectionEditProps = {
  viewingTag: Tag;
};

const TagsViewSectionEdit: React.FC<TagsViewSectionEditProps> = ({
  viewingTag,
}) => {
  const [editedTag, setEditedTag] = useState<Tag>(viewingTag);
  const [enableSave, setEnableSave] = useState(false);
  const { forceFetchAll } = useContext(AppContext);
  const [saving, setSaving] = useState(false);

  async function handleSave() {
    setSaving(true);
    const res = await sendUpdateTag({ tag: editedTag });
    if (res.rStatus === "error") {
      console.log("editedTag", editedTag);
      console.error("Error saving tag", res.message);
      genericFailureToast(`Error saving tag: ${res.message}`);
      setSaving(false);
      return;
    }

    if (res.rStatus === "success") {
      genericSuccessToast("Tag updated successfully");
      await forceFetchAll();
      setSaving(false);
    }
  }

  function handleCancel() {
    setEditedTag(viewingTag);
  }

  useEffect(() => {
    // if the values are the same setEnableSave to false
    if (
      editedTag.name === viewingTag.name &&
      editedTag.color === viewingTag.color
    ) {
      setEnableSave(false);
    } else {
      setEnableSave(true);
    }
  }, [editedTag, viewingTag]);

  return (
    <div className="m-auto border p-2 rounded">
      <div className="text-lg font-bold text-center">Edit Tag</div>
      <div className="flex flex-row gap-2 justify-center items-center mt-2">
        <ColorPicker
          value={editedTag.color}
          onChange={(color) => {
            setEditedTag({ ...editedTag, color });
          }}
        />
        <div>
          <Input
            value={editedTag.name}
            onChange={(e) => {
              setEditedTag({ ...editedTag, name: e.target.value });
            }}
          />
        </div>
      </div>
      <div
        className={`flex gap-2 ${
          enableSave ? "justify-between" : "justify-end"
        }`}
      >
        {enableSave && (
          <Button
            variant="outline"
            size={"sm"}
            className="mt-2"
            onClick={handleCancel}
          >
            Cancel
          </Button>
        )}

        <Button
          variant="outline"
          className="mt-2"
          size={"sm"}
          disabled={!enableSave || saving}
          onClick={handleSave}
        >
          {saving ? "Saving..." : "Save"}
        </Button>
      </div>
    </div>
  );
};

export default TagsViewSectionEdit;
